import { Subscription } from 'rxjs/index';

export class ChatProgressInfo {
  public progress: number;
  public file: File;
  public date: number;
  public errorMessages?: string;
  public uploadSubscription?: Subscription;

  constructor(progress: number, file: File, date: number) {
    this.progress = progress;
    this.file = file;
    this.date = date;
  }

  public getExtension() {
    const matches = this.file.name.match(/[^.\\/:*?"<>|\r\n]+$/g);
    return matches && matches[0];
  }
}
